var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVercel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-153 -46 652 652",
    style: {
      enableBackground: "new -153 -46 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.3,240.9c-23.4,0-40.3,15.3-40.3,38.2c0,22.9,19,38.2,42.4,38.2c14.2,0,26.6-5.6,34.4-15l-16.2-9.4 c-4.3,4.7-10.8,7.4-18.1,7.4c-10.2,0-18.8-5.3-22-13.8h59.5c0.5-2.4,0.7-4.8,0.7-7.4C208.6,256.1,191.8,240.9,168.3,240.9 L168.3,240.9z M148.2,271.6c2.7-8.5,9.9-13.8,20.1-13.8c10.2,0,17.4,5.3,20.1,13.8H148.2z M396.8,240.9c-23.4,0-40.3,15.3-40.3,38.2 c0,22.9,19,38.2,42.4,38.2c14.2,0,26.6-5.6,34.4-15l-16.2-9.4c-4.3,4.7-10.8,7.4-18.1,7.4c-10.2,0-18.8-5.3-22-13.8h59.5 c0.5-2.4,0.7-4.8,0.7-7.4C437.2,256.1,420.3,240.9,396.8,240.9L396.8,240.9z M376.8,271.6c2.7-8.5,9.9-13.8,20.1-13.8 c10.2,0,17.4,5.3,20.1,13.8H376.8L376.8,271.6z M294,279.1c0,12.7,8.3,21.2,21.2,21.2c8.7,0,15.3-4,18.7-10.4l16.3,9.4 c-6.7,11.2-19.4,18-35,18c-23.5,0-40.3-15.3-40.3-38.2c0-22.9,16.9-38.2,40.3-38.2c15.6,0,28.2,6.8,35,18l-16.3,9.4 c-3.4-6.5-9.9-10.4-18.7-10.4C302.3,257.8,294,266.3,294,279.1z M469,217.5v97.6h-19.1v-97.6H469z M-52.6,206.9l78.4,135.8H-131 L-52.6,206.9z M143.5,217.5L84.7,319.4L25.9,217.5h22.1l36.8,63.7l36.8-63.7H143.5z M268.5,243v20.6c-2.1-0.6-4.4-1-6.8-1 c-12.3,0-21.2,8.5-21.2,21.2v31.4h-19.1V243h19.1v19.5C240.5,251.7,253,243,268.5,243z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVercel);
export default __webpack_public_path__ + "static/media/Vercel.1f38065e5802377913f4eb1d82450dba.svg";
export { ForwardRef as ReactComponent };